import axios, { AxiosError } from 'axios'
import { type APIError } from '@/services/api/types'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  headers: {
    Authorization: 'Bearer ' + import.meta.env.VITE_API_TOKEN,
  },
})

export function axiosErrorHandler(error: unknown) {
  if (error instanceof AxiosError) {
    if (error.code === 'ERR_NETWORK') {
      return {
        message: 'network_error',
      } as APIError
    }
    // Prefer the server-provided error code (e.g. `permission_denied`) so the
    // user sees a meaningful message instead of the generic `bad_request` that
    // Axios assigns to every 4xx response.
    const serverMessage = error.response?.data?.errors?.message
    if (typeof serverMessage === 'string' && serverMessage.length > 0) {
      return { message: serverMessage } as APIError
    }
    if (error.code === 'ERR_BAD_REQUEST') {
      return {
        message: 'bad_request',
      } as APIError
    }
  } else if (error === 'socket_init') {
    return {
      message: 'socket_init',
    } as APIError
  }
  return {
    message: 'unknown_error',
  } as APIError
}
